var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    ImageSlide       = require("app/ui/ImageSlide"),
    get              = require("object-path").get,
    kind             = require("enyo/kind"),
    onHyperlinkTap   = require("app/utils/onHyperlinkTap");

module.exports = kind(/** @lends  app.ui.HyperLinkImageSlide.prototype */ {

    /**
     * @private
     */
    name: "app.ui.HyperLinkImageSlide",

    /**
     * @private
     */
    kind: ImageSlide,

    /**
     * @private
     */
    classes: "app-ui-hyper-link-image-slide",

    /**
     * @private
     */
    mixins: [
        HyperLinkSupport
    ],

    /**
     * @private
     */
    handlers: {
        ontap: "onHyperlinkTap"
    },

    /**
     * Determine which image source to use
     *
     * @private
     */
    update: kind.inherit(function(sup) {
        return function() {
            var data   = this.data || {},
                link;

            sup.apply(this, arguments);
            link = get(data, "link_to", null);
            this.set("href", link ? link : null);
        };
    }),

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: function() {
        return onHyperlinkTap.call(this, this);
    }

});
